<template>
  <div>
    <breadcrumb>
      <template v-slot:1
        ><router-link :to="{ name: 'configuracion-carta' }">{{
          $t("configuracionCarta")
        }}</router-link></template
      >
      <template v-slot:2>{{ $t("restriccionesProductos") }}</template>
    </breadcrumb>
    <!-- <CabeceraInformes
      :idBusiness="idBusiness"
      :listBusinesses="listBusinesses"
      :idTpv="idTpv"
      :listTpv="listTpv"
      :quitarFechas="true"
      :quitarConsultas="true"
      id="cabecera"
    /> -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="listBusiness"
                  ><strong>{{ $t("negocio") }}</strong></label
                >
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="getTpv()"
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-5" v-if="listCartas.length > 1">
              <div class="form-group">
                <label
                  ><strong>{{ $t("cartaASecas") }}</strong></label
                >
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idCarta"
                  @change="getProductosCarta()"
                  filterable
                  :placeholder="$t('seleccionaUnaCarta')"
                >
                  <el-option
                    v-for="cart in listCartas"
                    class="select-primary"
                    :value="cart.id"
                    :label="cart.nombreMostrado"
                    :key="cart.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="inicio"></div>
    <div class="col-md-12 col-sm-12" v-if="tienePermisos">
      <div class="card">
        <div class="row">
          <div class="col-10">
            <div class="form-group" v-if="listRestricciones.length < 1">
              <button
                class="btn btn-primary mr-3"
                type="button"
                @click="nuevaRestriccion"
              >
                <i class="fa fa-plus-square"></i>&nbsp;&nbsp;{{ $t("nueva") }}
                {{ $t("restriccion") }}
              </button>
            </div>
          </div>

          <div class="col-2" v-if="tienePermisos">
            <div class="form-group" id="info">
              <b-button
                v-b-popover.focus.topleft="{
                  content: $t('inforestriccionesproducto'),
                }"
                title="Información"
                class="btn btn-primary mr-3"
                type="button"
              >
                <i class="fas fa-info"></i>
              </b-button>
            </div>
          </div>
        </div>
        <div
          class="table-responsive "
          v-if="listRestricciones.length > 0 && respuesta"
        >
          <table class="table table-bordered table-striped">
            <thead class="thead-dark">
              <tr>
                <th class="text-center" width="15%">{{ $t("tipo") }}</th>

                <th class="text-center" width="15%">{{ $t("horaInicio") }}</th>
                <th class="text-center" width="15%">{{ $t("horaFin") }}</th>
                <th class="text-center" width="15%">{{ $t("dia") }}</th>
                <th class="text-center" width="15%">{{ $t("acciones") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="restriccion in listRestricciones"
                :key="restriccion.id"
              >
                <td class="text-center">
                  <div>Alcohol</div>
                  <!-- <div>{{ restriccion.tipo_producto }}</div> -->
                </td>
                <td>
                  <div class="text-center">
                    {{ restriccion.fecha_inicio_str }}
                  </div>
                </td>
                <td>
                  <div class="text-center">{{ restriccion.fecha_fin_str }}</div>
                </td>
                <td>
                  <div class="text-center">Todos los dias</div>
                  <!-- <div class="text-center">{{ restriccion.tipo_duracion }}</div> -->
                </td>
                <td align="center">
                  <div class="btn btn-link btn-xs">
                    <i
                      class="fas fa-pencil-alt"
                      v-tooltip.top-center="$t('editar')"
                      style="color: orange"
                      @click="editarRestriccion(restriccion)"
                    ></i>
                  </div>

                  <!-- <div class="btn btn-danger btn-link btn-xs">
                    <i
                      v-tooltip.top-center="$t('borrar')"
                      class="fas fa-trash-alt text-danger"
                    ></i>
                  </div> -->
                  <div
                    class="btn btn-danger btn-link btn-xs"
                    style="margin-top:5px;"
                  >
                    <el-checkbox
                      @change="
                        changeNoDisponible(restriccion.id, restriccion.activo)
                      "
                      v-model="restriccion.activo"
                    >
                      <template></template>
                      <strong
                        >{{
                          restriccion.activo
                            ? $t("resActiva")
                            : $t("resInactiva")
                        }}
                      </strong>
                    </el-checkbox>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-danger" role="alert">
          {{ $t("noHayRestriccionesParaProductos") }}
        </div>
      </div>
    </div>
    <template v-if="!tienePermisos">
      <div class="col-md-12">
        <div class=" alert alert-primary" align="center">
          <h3>
            <i class="fas fa-exclamation-circle"></i>
            {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
          </h3>

          <span>
            {{ $t("paraMasInformacionContacteConSu") }}
            <strong>{{ $t("distribuidor") }}</strong
            >.</span
          >
        </div>
      </div>
    </template>

    <!-- <template v-if="!tienePermisos && inicio">
      <div class="col-md-12">
        <div class=" alert alert-primary" align="center">
          <h3>
            <i class="fas fa-exclamation-circle"></i>
            {{ $t("usuarioSinAcceso") }}.
          </h3>

          <span>
            {{ $t("paraMasInformacionContacteConSu") }}
            <strong>{{ $t("distribuidor") }}</strong
            >.</span
          >
        </div>
      </div>
    </template> -->

    <modal
      name="modalNuevoEditarRestriccion"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ getAccion() }} {{ $t("restriccion") }}</h4>
        </div>
        <div class="modal-body">
          <!--<input type="text" v-model="restriccion.descripcion" />-->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t("tipo") }}</label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="restriccion.tipo_producto"
                  :placeholder="'Seleccione un tipo de restricción'"
                >
                  <el-option
                    v-for="tipo in listTipos"
                    class="select-primary"
                    :value="tipo.value"
                    :label="tipo.nombre"
                    :key="tipo.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>{{ $t("horaInicio") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  type="time"
                  class="theme-numier"
                  :title="$t('horaInicio')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  format="HH:mm"
                  v-model="restriccion.fecha_inicio"
                ></datetime>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>{{ $t("horaFin") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  type="time"
                  class="theme-numier"
                  :title="$t('horaFin')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  format="HH:mm"
                  v-model="restriccion.fecha_fin"
                ></datetime>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t("diaDeLaSemana") }}</label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="restriccion.tipo_duracion"
                  filterable
                  :placeholder="$t('seleccioneDiaDeLaSemana')"
                >
                  <el-option
                    v-for="dia in listDias"
                    class="select-primary"
                    :value="dia.value"
                    :label="dia.dia"
                    :key="dia.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            class="btn btn-danger"
            @click="$modal.hide('modalNuevoEditarRestriccion')"
          >
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button
            class="btn btn-primary"
            @click="modalConfirmation(restriccion.id)"
          >
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "../../../../../components/CabeceraInformes/CabeceraInformes.vue";
import swal from "sweetalert2";
import {
  DatePicker,
  Select,
  Option,
  Loading,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  Switch,
} from "element-ui";

export default {
  name: "RestriccionesProducto",
  components: {
    Breadcrumb,
    CabeceraInformes,
    [Checkbox.name]: Checkbox,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.getBusiness();
  },
  updated() {},
  data() {
    return {
      idBusiness: 0,
      idTpv: 0,
      accion: 0,
      listTpv: [],
      listBusinesses: [],
      listRestricciones: [],
      respuesta: true,
      tienePedidos: false,
      inicio: true,
      restriccion: {},
      configcarta: {},
      listCartas: [],
      tienePermisos: true,
      listDias: [
        { value: 1, dia: "Todos los dias" },
        // { value: 2, dia: "Todos los lunes" },
        // { value: 3, dia: "Todos los martes" },
        // { value: 4, dia: "Todos los miércoles" },
        // { value: 5, dia: "Todos los jueves" },
        // { value: 6, dia: "Todos los viernes" },
        // { value: 7, dia: "Todos los sábados" },
        // { value: 8, dia: "Todos los domingos" },
      ],
      listTipos: [
        { value: "A", nombre: this.$t("alcohol") },
        //{ value: 2, nombre: "Todos los días"},
        //{ value: 3, nombre: "Ejemplo"}
      ],
    };
  },
  methods: {
    changeNoDisponible(idRestr, activo) {
      this.restriccion.activo = activo;

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        idRestriccion: idRestr,
        activo: activo,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "updateActivaRestriccion";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getRestriccionesProductCartaByTpv();

            let notify = vm.$t("editado");
            vm.$notify({
              message:
                vm.$t("Restricción") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    getAccion() {
      return this.restriccion.id == -1 ? "Nueva" : "Editar";
    },

    modalConfirmation(idRestriccion) {
      var hora_inicio = new Date(this.restriccion.fecha_inicio)
        .getHours()
        .toString();
      var minuto_inicio = new Date(this.restriccion.fecha_inicio)
        .getMinutes()
        .toString();
      var hora_fin = new Date(this.restriccion.fecha_fin).getHours().toString();
      var minuto_fin = new Date(this.restriccion.fecha_fin)
        .getMinutes()
        .toString();

      if (hora_fin.length <= 1) {
        hora_fin = "0" + hora_fin;
      }

      if (minuto_fin.length <= 1) {
        minuto_fin = "0" + minuto_fin;
      }

      if (hora_inicio.length <= 1) {
        hora_inicio = "0" + hora_inicio;
      }

      if (minuto_inicio.length <= 1) {
        minuto_inicio = "0" + minuto_inicio;
      }
      var inicio = "" + hora_inicio + minuto_inicio;
      var fin = "" + hora_fin + minuto_fin;

      if (this.restriccion.tipo != "L") {
        this.restriccion.num_maximo = 0;
      }
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        tipo_producto: this.restriccion.tipo_producto,
        fecha_inicio: parseInt(inicio),
        fecha_fin: parseInt(fin),
        tipo_duracion: this.restriccion.tipo_duracion,
        idBusinessInfo: this.idBusinessInfo,
        idBusiness: this.idBusiness,
        activo: this.restriccion.activo,

        jwt: this.$store.getters.jwt,
      };

      if (idRestriccion != -1) {
        params = {
          idRestriccion: idRestriccion,
          tipo_producto: this.restriccion.tipo_producto,
          fecha_inicio: parseInt(inicio) == 0 ? 2400 : parseInt(inicio),
          fecha_fin: parseInt(fin) == 0 ? 2400 : parseInt(fin),
          tipo_duracion: this.restriccion.tipo_duracion,
          idBusinessInfo: this.idBusinessInfo,
          idBusiness: this.idBusiness,
          activo: this.restriccion.activo,
          jwt: this.$store.getters.jwt,
        };
      }

      let vm = this;
      let controller =
        idRestriccion == -1
          ? "crearRestriccionProductsCarta"
          : "editarRestriccionProductsCarta";

      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getRestriccionesProductCartaByTpv();

            vm.$modal.hide("modalNuevoEditarRestriccion");

            if (vm.restriccion.id != -1) {
              vm.$notify({
                message:
                  vm.$t("restriccion") +
                  " " +
                  vm.$t("editada") +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              vm.$notify({
                message:
                  vm.$t("restriccion") +
                  " " +
                  vm.$t("creada") +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    // permisoCarta() {
    //   console.log("permisos");
    //   var config = {
    //     params: {
    //       idBusiness: this.idBusiness,
    //       jwt: this.$store.getters.jwt,
    //     },
    //     headers: { Authorization: "Bearer " + this.$store.getters.jwt },
    //   };
    //   this.$store.dispatch("setIdBusiness", this.idBusiness);
    //   let vm = this;
    //   this.axios
    //     .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
    //     .then(function(response) {
    //       if (response.data.response) {
    //         if (response.data.result.permiso) {
    //           response.data.result.listCartas.forEach((element) => {
    //             if (element.idTpv == vm.idTpv) {
    //               console.log("entro");
    //               vm.tienePedidos = element.tiene_pedidos == "1" ? true : false;
    //               vm.inicio = false;
    //             }
    //           });
    //         } else {
    //           vm.permiso = response.data.result.permiso;
    //         }
    //       } else {
    //         swal({
    //           title: vm.$t("atencion"),
    //           text: response.data.message,
    //           confirmButtonClass: "btn btn-info btn-fill",
    //           type: "error",
    //         });
    //       }
    //     });
    // },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.listBusinesses = response.data.result;
          vm.getTpv();
          
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    permisoCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          estado: this.estado,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
        .then(function(response) {
          if (response.data.response) {
            response.data.result.listCartas.forEach((element) => {

              if (element.idTpv == vm.idTpv) {
                vm.tienePermisos = element.tiene_pedidos == 1 ? true : false;
                vm.inicio = true;
              }
            });

            vm.listCartas = [
              {
                nombreMostrado: vm.$t("esteNegocioNoContieneNingunaCarta"),
                id: 0,
              },
            ];
            vm.idCarta = 0;

            if (response.data.result.permiso) {
              // console.log(response)
              vm.permiso = response.data.result.permiso;
              vm.sellingPoint =
                response.data.result.listCartas[0].sinqroSellingPoint;

              //vm.nameRoute = response.data.result.nameroute;
              //vm.logoNegocio = response.data.result.imagen;

              vm.listCartas = response.data.result.listCartas;

              response.data.result.listCartas.forEach(function(x) {
                if (x.tokenServerSinqro) {
                  vm.tokenServerSinqro = x.tokenServerSinqro;
                }

                if (x.tokenUserSinqro) {
                  vm.tokenUserSinqro = x.tokenUserSinqro;
                }

                if (x.tiene_sinqro) {
                  if (x.tiene_sinqro == "1") {
                    vm.tieneSinqro = true;
                  } else {
                    vm.tieneSinqro = false;
                  }
                }

                if (x.noRecoger == true) {
                  vm.noRecoger = "1";
                } else {
                  vm.noRecoger = "0";
                }

                if (x.noDomicilio == true) {
                  vm.noDomicilio = "1";
                } else {
                  vm.noDomicilio = "0";
                }

                if (x.multiCartaSinqro == true) {
                  vm.multiCartaSinqro = true;
                } else {
                  vm.multiCartaSinqro = false;
                }
              });
              vm.idCarta = response.data.result.listCartas[0].id;
              vm.descripcionCarta =
                response.data.result.listCartas[0].descripcionCarta;

              /*vm.noRecoger = response.data.result.listCartas[0].config.filter(
                (item) => item.idConfig == "22"
              )[0];
              vm.noDomicilio = response.data.result.listCartas[0].config.filter(
                (item) => item.idConfig == "7"
              )[0];*/

              vm.getProductosCarta();
            } else {
              vm.permiso = response.data.result.permiso;
              vm.tienePermisos = false;
            }
          } else {

            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getProductosCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idTipo: this.idTipo,
          idCarta: this.idCarta,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getProductsCarta", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listProductosCarta = response.data.result;

            vm.respuesta = true;
          } else {

            //Sin permisos de usuario
            vm.tienePermisos = false;

            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      const tempconfig = this.listCartas.find((elm) => elm.id == this.idCarta)
        .config;

      /*this.listCartas.forEach(carta => {
        if(this.idCarta == carta.id) {
          this.sellingPoint = carta.sellingPoint;
        }
      });*/

      if (tempconfig && tempconfig.length > 0) {
        tempconfig.forEach((element) => {
          const el = {};
          el[element.nombre] = element.valor != 0;
          Object.assign(this.configcarta, el);
          //  this.configcarta.push(el)
        });
      }
    },
    getBusinessInfo() {
      var config = {
        params: {
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getIdBusinessInfoByIdTpv",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.idBusinessInfo = response.data.result;
            vm.respuesta = true;
          } else {
            vm.tienePermisos = false;
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("esteNegocioNoTieneCarta"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
            vm.newButton = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            if (vm.listTpv.length > 0) {
              vm.idTpv = vm.listTpv[0].id;
              vm.getBusinessInfo();
              vm.permisoCarta();
              vm.getRestriccionesProductCartaByTpv();
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          //vm.loading.close();
        });
    },
    cambioBusiness(idBusinessData, listTpv) {
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = 0;
      this.listaAreas = [];
      this.getTpv();
    },
    emitirConsulta() {},
    cambioTpv(idTpvData) {
      this.idTpv = idTpvData;
      this.listaAreas = [];
    },

    editarRestriccion(restriccion) {
      var inicio =
        "2020-11-17T" + restriccion.fecha_inicio_str + ":00.000+01:00";
      var fin = "2020-11-17T" + restriccion.fecha_fin_str + ":00.000+01:00";
      this.restriccion = {
        id: restriccion.id,
        tipo_producto: "A",
        tipo_duracion: 1,
        fecha_inicio: inicio,
        fecha_fin: fin,
        activo: restriccion.activo,
      };
      this.$modal.show("modalNuevoEditarRestriccion");
    },
    nuevaRestriccion() {
      this.restriccion = {
        id: -1,
        tipo_producto: "A",
        tipo_duracion: 1,
        fecha_inicio: "2020-11-17T23:00:00.000+01:00",
        fecha_fin: "2020-11-17T07:00:00.000+01:00",
        activo: true,
      };
      this.$modal.show("modalNuevoEditarRestriccion");
    },
    getRestriccionesProductCartaByTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/getRestriccionProductsCarta",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listRestricciones = response.data.result;
            vm.respuesta = true;
          }
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
  },
};
</script>

<style>
.popover {
  background-color: #5bc0de5b !important;
  font-size: 0.9rem;
  justify-content: center;
}

.bs-popover-top > .arrow::after,
.bs-popover-auto[x-placement^="top"] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #bfe4ef !important;
}

.popover-header {
  top: 0%;
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  margin-top: 0;
  font-size: 1.2rem;
  background-color: #5bc0de9f !important;
  border-bottom: 1px solid #5bc0ded5 !important;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
</style>

<style scoped>
#info {
  float: right !important;
}

.mr-3,
.mx-3 {
  margin-right: 0rem !important;
}
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
}

tbody td {
  padding: 0 !important;
}

td div {
  padding: 12px 8px 15px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Productos/RestriccionesProducto.vue